





























































































































































import { Component, Vue } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings'
import { AppModule } from '@/store/modules/app';
import ConversationTopicDto from '@/models/ConversationTopics/ConversationTopicDto';
import ConversationTopicEdit from '@/components/ConversationTopics/ConversationTopicEdit.vue';
import ConversationTopicCreate from '@/components/ConversationTopics/ConversationTopicCreate.vue';
import GiganautVue from '@/components/Shared/GiganautVue';
import { VuetifyConfirmObject } from 'vuetify-confirm';
import ConversationTopicType from '@/models/ConversationTopics/ConversationTopicType';

@Component({
  name: 'ConversationTopics',
  components: { ConversationTopicEdit, ConversationTopicCreate }
})
export default class extends GiganautVue {
    
    conversationTopicType = ConversationTopicType;
    async beforeMount() {
        AgencySettingsModule.updateCurrentConversationTopic(null);
    }

    async updateCurrentConversationTopic(conversationTopic: ConversationTopicDto) {
        AgencySettingsModule.updateCurrentConversationTopic(conversationTopic);
    }

    get currentConversationTopic() {
        return AgencySettingsModule.currentConversationTopic;
    }

    get loading() {
        return AgencySettingsModule.loadingConversationTopics;
    }

    get conversationTopics() {
        return AgencySettingsModule.conversationTopics;
    }

    async deleteConversationTopic(conversationTopic: ConversationTopicDto) {
        const options: VuetifyConfirmObject = {
                buttonTrueText: "DELETE",
                buttonFalseText: "CANCEL",
                buttonTrueColor: "primary",
                buttonFalseColor: "primary",
        }
        const result = await this.$confirm('Are you sure you want to delete the conversation topic ' + conversationTopic.name + '?', options);
        // if (result) {
        //     const request = new UpdateAgencyUserStatusRequest();
        //     request.updatedAt = user.updatedAt;
        //     request.status = AgencyUserStatusEnum.Deleted;
        //     await AgencySettingsModule.deleteAgencyUser(request);
        // }
  }
}
